import { customEmailConstants } from '../../_constants';
import { customEmailService } from '../../_services';

export const sendRemainderAction = {
    sendRemainderHandler
};

function sendRemainderHandler(data,callback) {
    return dispatch => {
        dispatch(request());
        customEmailService.sendRemainderHandler(data)
            .then(
                sendRemainder => {
                    dispatch(success(sendRemainder));
                    callback()
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: customEmailConstants.REQUEST_SEND_REMAINDER } }
    function success(sendRemainder) { return { type: customEmailConstants.RECIEVE_SEND_REMAINDER, sendRemainder } }
    function failure(error) { return { type: customEmailConstants.ERROR_SEND_REMAINDER, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/CustomEmails/sendRemainder.action.js